// BarcodeCard.js
import React, { useEffect, useState } from 'react';
import Barcode from 'react-barcode';
import { useAuthenticator } from '@aws-amplify/ui-react';
import { Card, CardContent, Typography } from '@mui/material';
import './BarcodeCard.css'; // 必要に応じてカスタムCSSをインポート

function BarcodeCard() {
  const { user } = useAuthenticator((context) => [context.user]);
  const [customerCode, setCustomerCode] = useState('');

  useEffect(() => {
    // ローカルストレージから会員コードを取得
    const localCustomerCode = localStorage.getItem('customerCode');
    if (localCustomerCode) {
      setCustomerCode(localCustomerCode);
    } else {
      console.warn('ローカルストレージに customerCode が見つかりません');
    }
  }, []);

  return (
    <Card sx={{ maxWidth: 400, margin: 'auto', padding: '20px' }}>
      <CardContent style={{ textAlign: 'center' }}>
        {/* 上部中央に「会員証」を表示 */}
        <Typography variant="h5" component="div" gutterBottom>
          会員証
        </Typography>
        {/* バーコードを表示 */}
        {customerCode ? (
          <div className="barcode-container" style={{ marginTop: '20px' }}>
            <Barcode value={customerCode} format="CODE128" width={1.5} height={100} />
          </div>
        ) : (
          <Typography color="error">表示するカスタマーコードがありません</Typography>
        )}
      </CardContent>
    </Card>
  );
}

export default BarcodeCard;
